import { useAuthStore } from '../stores/authStore';
import type { User } from '../types';

/**
 * Feature rollout flags. The server decides (FEATURE_* in its .env) and reports them on login
 * and /auth/me as `features`; the UI only gates on what the server said. VITE_FEATURE_* is a
 * local-development override so a screen can be built against a backend that has the flag off.
 */
export const ticketsEnabled = (user: User | null | undefined): boolean =>
  import.meta.env.VITE_FEATURE_TICKETS === 'true' || !!user?.features?.tickets;

export const forecastEnabled = (user: User | null | undefined): boolean =>
  import.meta.env.VITE_FEATURE_FORECAST === 'true' || !!user?.features?.forecast;

export function useTicketsEnabled(): boolean {
  const user = useAuthStore((s) => s.user);
  return ticketsEnabled(user);
}

export function useForecastEnabled(): boolean {
  const user = useAuthStore((s) => s.user);
  return forecastEnabled(user);
}

export const faceSearchEnabled = (user: User | null | undefined): boolean =>
  import.meta.env.VITE_FEATURE_FACE_SEARCH === 'true' || !!user?.features?.face_search;

export function useFaceSearchEnabled(): boolean {
  const user = useAuthStore((s) => s.user);
  return faceSearchEnabled(user);
}
